export default __webpack_public_path__ + "static/media/summerGolf.74d4797e.jpeg";